import { render, staticRenderFns } from "./UsersPrivilegeEstablishmentsSettings.vue?vue&type=template&id=6e808e5e&scoped=true&"
import script from "./UsersPrivilegeEstablishmentsSettings.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeEstablishmentsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e808e5e",
  null
  
)

export default component.exports